/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-corporate': {
    width: 48,
    height: 48,
    viewBox: '0 0 48 48',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M8 16a2 2 0 00-2 2v20a2 2 0 002 2h32a2 2 0 002-2V18a2 2 0 00-2-2H8zm-6 2a6 6 0 016-6h32a6 6 0 016 6v20a6 6 0 01-6 6H8a6 6 0 01-6-6V18z" _fill="#FFF"/><path pid="1" fill-rule="evenodd" clip-rule="evenodd" d="M15.757 5.757A6 6 0 0120 4h8a6 6 0 016 6v32a2 2 0 11-4 0V10a2 2 0 00-2-2h-8a2 2 0 00-2 2v32a2 2 0 11-4 0V10a6 6 0 011.757-4.243z" _fill="#FFF"/>'
  }
})
